import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ContactImg1 from "../../assets/img/contact1.png";
import ContactImg2 from "../../assets/img/contact3.png";
import ContactImg3 from "../../assets/img/contact4.png";
import MessageAPI from "../../services/NavaService";
import Swal from "sweetalert2";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const isValid = Boolean(
    (form.name || "").toString().trim() &&
    (form.email || "").toString().trim() &&
    (form.subject || "").toString().trim() &&
    (form.message || "").toString().trim()
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValid || status === "sending") return;

    setStatus("sending");
    try {
      await MessageAPI.postMessages({
        firstName: form.name,
        email: form.email,
        subject: form.subject,
        message: form.message,
      });

      setStatus("success");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  const customAlert = (v, w) => {
    Swal.fire({
      text: v,
      icon: w,
      didOpen: () => {
        const container = document.querySelector(".swal2-container");
        const popup = document.querySelector(".swal2-popup");
        if (container) container.style.zIndex = "10010";
        if (popup) popup.style.zIndex = "10011";
      }
    });
  };

  const [isLarge, setIsLarge] = useState(
    typeof window !== "undefined" ? window.matchMedia("(min-width: 992px)").matches : false
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia("(min-width: 992px)");
    const handler = (e) => setIsLarge(e.matches);

    setIsLarge(mq.matches);

    if (mq.addEventListener) mq.addEventListener("change", handler);
    else mq.addListener(handler);

    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", handler);
      else mq.removeListener(handler);
    };
  }, []);

  return (
    <Wrapper id="contact">
      <div className="lightBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Let's get in touch</h1>
            <p className="font13">
              We’d love to hear from you. Whether you’re exploring solar solutions, need expert advice, or want to partner with us,
              <br />
              our team is ready to help. Get in touch today and let’s take the next step toward a sustainable energy future together.
            </p>
          </HeaderInfo>
          <div className="row" style={{ paddingBottom: "30px" }}>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <Form onSubmit={handleSubmit}>
                <label className="font13">First name:</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  className="font20 extraBold"
                  required
                />
                <label className="font13">Email:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className="font20 extraBold"
                  required
                />
                <label className="font13">Subject:</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={form.subject}
                  onChange={handleChange}
                  className="font20 extraBold"
                  required
                />
                <textarea
                  rows="4"
                  cols="50"
                  id="message"
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  className="font20 extraBold"
                  required
                />
                <SumbitWrapper className="flex">
                  <ButtonInput
                    type="submit"
                    value={status === "sending" ? "Sending..." : "Send Message"}
                    className="pointer animate radius8"
                    style={{ maxWidth: "220px", opacity: (!isValid || status === "sending") ? 0.6 : 1 }}
                    disabled={!isValid || status === "sending"}
                  />
                </SumbitWrapper>
              </Form>

              {status === "success" && <p style={{ color: "green" }}>Message sent — thank you!</p>}
              {status === "error" && <p style={{ color: "red" }}>Failed to send message. Try again later.</p>}
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <ImagesCol>
                <LeftStack>
                  <ContactImgBox>
                    <img src={ContactImg1} alt="office" className="radius6" />
                  </ContactImgBox>
                  <ContactImgBox>
                    <img src={ContactImg2} alt="office" className="radius6" />
                  </ContactImgBox>
                </LeftStack>

                {isLarge && (
                  <RightImgWrapper>
                    <MainImgWrapper>
                      <img src={ContactImg3} alt="office" className="radius6" />
                    </MainImgWrapper>
                  </RightImgWrapper>
                )}

              </ImagesCol>
            </div>

          </div>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  padding: 70px 0 30px 0;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Form = styled.form`
  padding: 70px 0 30px 0;
  input,
  textarea {
    width: 100%;
    background-color: transparent;
    border: 0px;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #707070;
    height: 30px;
    margin-bottom: 30px;
  }
  textarea {
    min-height: 100px;
  }
  @media (max-width: 860px) {
    padding: 30px 0;
  }
`;
const ButtonInput = styled.input`
  border: 1px solid #7620ff;
  background-color: #7620ff;
  width: 100%;
  outline: none;
  color: #0c0c0cff;
  :hover {
    background-color: #580cd2;
    border: 1px solid #7620ff;
    color: #ffffffff;
  }
  @media (max-width: 991px) {
    margin: 0 auto;
  }
`;

const SumbitWrapper = styled.div`
  @media (max-width: 991px) {
    width: 100%;
    margin-bottom: 50px;
  }
`;

const ImagesCol = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;

  @media (max-width: 991px) {
    flex-direction: column;
    align-items: center;
  }
`;

const LeftStack = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-end; 
  
  @media (max-width: 991px) {
    width: 100%;
    align-items: center;
  }
`;

const RightImgWrapper = styled.div`
  width: 50%;
  display: flex;
  align-items: flex-start;
  margin-top: 100px;

  @media (max-width: 991px) {
    width: 100%;
    margin-top: 20px;
    justify-content: center;
  }

  @media (min-width: 992px) {
    max-width: 520px;  
  }
`;

const ContactImgBox = styled.div`
  max-width: 180px;
  align-self: flex-end;
  margin: 10px 30px 10px 0;

  @media (max-width: 991px) {
    align-self: center;
    margin: 10px auto;
    max-width: 220px;
    width: 90%;
  }

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

const MainImgWrapper = styled.div`
  width: 100%;
  @media (min-width: 992px) {
    height: 440px;         
  }

  @media (max-width: 1160px) and (min-width: 992px) {
    height: 380px;
  }

  @media (max-width: 991px) {
    height: auto;
    width: 100%;
  }

  overflow: hidden;
  border-radius: 8px;

  img {
    width: 100%;
    height: 100%;       
    object-fit: cover;   
    display: block;
  }
`;


